import Footer from "./components/Footer";
import GetStarted from "./components/GetStarted";
import Hero from "./components/Hero";
import Navbar from "./components/Navbar";
import Statistics from "./components/Statistics";
import UrlLink from "./components/UrlLink";

function App() {
  return (
<>
<Navbar/>
<Hero/>

<Statistics/>
<GetStarted/>
<Footer/>
</>
  );
}

export default App;
